import React, { useState, useEffect } from 'react';

// Axios
import axios from 'axios';

// Toast
import { toast } from 'react-toastify';

// MUI Components
import Box from '@mui/material/Box';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// Components
import AlertModal from '../alert-modal';
import ConfirmModal from '../confirm-modal';

const ScheduledAlerts = () => {

    const [ alertType, setAlertType ]                       = useState('notification');
    const [ editNotice, setEditNotice ]                     = useState(null);
    const [ editNoticeModalOpen, setEditNoticeModalOpen ]   = useState(false);
    const [ editEmail, setEditEmail ]                       = useState(null);
    const [ editEmailModalOpen, setEditEmailModalOpen ]     = useState(false);
    const [ confirmDeleteNoticeOpen, setConfirmDeleteNoticeOpen ] = useState(false);
    const [ confirmDeleteNoticeId, setConfirmDeleteNoticeId ]     = useState(null);
    
    const [ alertFilters, setAlertFilters ] = useState({
        is_active: true,
        start_datetime: null,
        end_datetime: null
    });
    const [ siteNotices, setSiteNotices ]   = useState([]);
    const [ emails, setEmails ]             = useState([]);

    const getSiteNotices = () => {
        axios.get('/notices', {
            params: alertFilters
        }).then(response => {
            setSiteNotices(response.data.notices);
        });
    }

    const getEmails = () => {
        axios.get('/emails').then(response => {
            setEmails(response.data.emails);
        });
    }

    const deleteNotice = (id) => {
        setConfirmDeleteNoticeOpen(true);
        setConfirmDeleteNoticeId(id);
    }

    const confirmDeleteNotice = () => {
        setConfirmDeleteNoticeOpen(false);
        axios.post(`/notice/${confirmDeleteNoticeId}/delete`).then(response => {
            if( response.data.success ){
                toast.success('Notice deleted successfully');
                getSiteNotices();
            }
            else{
                toast.error(response.data.message);
            }
        });
    }

    useEffect(() => {
        getSiteNotices();
        getEmails();
    }, []);

    useEffect(() => {
        if( editNotice ){
            setEditNoticeModalOpen(true);
        }
        else{
            setEditNoticeModalOpen(false);
        }
    }, [editNotice]);

    useEffect(() => {
        if( !editNoticeModalOpen ){
            setEditNotice(null);
        }
    }, [editNoticeModalOpen]);

    useEffect(() => {
        if( editEmail ){
            setEditEmailModalOpen(true);
        }
        else{
            setEditEmailModalOpen(false);
        }
    }, [editEmail]);

    useEffect(() => {
        if( !editEmailModalOpen ){
            setEditEmail(null);
        }
    }, [editEmailModalOpen]);

    return (
        <Box>
            <ButtonGroup>
                <Button onClick={() => setAlertType('notification')} variant={alertType === 'notification' ? 'contained' : 'outlined'}>Site Notice</Button>
                <Button onClick={() => setAlertType('email')} variant={alertType === 'email' ? 'contained' : 'outlined'}>Email</Button>
            </ButtonGroup>
            {alertType === 'notification' ? (
                <Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Site</TableCell>
                                <TableCell>Notice Type</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Start Time</TableCell>
                                <TableCell>End Time</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {siteNotices.map(notice => (
                                <TableRow key={notice.id}>
                                    <TableCell>{notice.site ? notice.site.domain : 'All Sites'}</TableCell>
                                    <TableCell>{notice.type}</TableCell>
                                    <TableCell>{notice.message ? notice.message.substring(0, 20) + '...' : '--'}</TableCell>
                                    <TableCell>{notice.start_datetime ? new Date(notice.start_datetime).toLocaleString() : '--'}</TableCell>
                                    <TableCell>{notice.end_datetime ? new Date(notice.end_datetime).toLocaleString() : '--'}</TableCell>
                                    <TableCell>
                                        <Box className='actions-cell'>
                                            <Button variant='text' color='primary' onClick={() => setEditNotice(notice)}>
                                                <EditIcon />
                                            </Button>
                                            <Button variant='text' color='error' onClick={() => deleteNotice(notice.id)}>
                                                <DeleteIcon />
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <ConfirmModal
                        open={confirmDeleteNoticeOpen}
                        setOpen={setConfirmDeleteNoticeOpen}
                        title='Delete Notice'
                        message='Are you sure you want to delete this notice?'
                        onConfirm={confirmDeleteNotice}
                        onCancel={() => setConfirmDeleteNoticeOpen(false)}
                    />
                    <AlertModal open={editNoticeModalOpen} setOpen={setEditNoticeModalOpen} existingAlert={editNotice} />
                </Box>
            ) : (
                <Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Site</TableCell>
                                <TableCell>Subject</TableCell>
                                <TableCell>Content</TableCell>
                                <TableCell>Send At</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {emails.map(email => (
                                <TableRow key={email.id}>
                                    <TableCell>{email.site.domain}</TableCell>
                                    <TableCell>{email.subject ? email.subject : '--'}</TableCell>
                                    <TableCell>{email.content ? email.content.substring(0, 20) + '...' : '--'}</TableCell>
                                    <TableCell>{email.send_at ? new Date(email.send_at).toLocaleString() : '--'}</TableCell>
                                    <TableCell>
                                        <Box className='actions-cell'>
                                            <Button variant='text' color='primary' onClick={() => setEditEmail(email)}>
                                                <EditIcon />
                                            </Button>
                                            <Button variant='text' color='error'>
                                                <DeleteIcon />
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <AlertModal open={editEmailModalOpen} setOpen={setEditEmailModalOpen} existingEmail={editEmail} />
                </Box>
            )}
        </Box>
    );

}

export default ScheduledAlerts;